import { set, toggle } from "@/utils/vuex";

export default {
  setDrawer: set("drawer"),
  setImage: set("image"),
  setColor: set("color"),
  toggleDrawer: toggle("drawer"),

  setSnackBar(state, data) {
    state.snack.text = data.text;
    state.snack.color = data.color;
    state.snack.display = true;
  },
  clearSnackBar(state) {
    state.snack.text = null;
    state.snack.display = false;
  },

  loading(state, loading) {
    state.loading = loading;
  }
};
